import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Noise } from "@/components/atoms";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Einsatz } from "@/components/Einsatz";
import { CaseStudies } from "@/components/CaseStudies";
import { MoreProjects } from "@/components/MoreProjects";
import { Experience } from "@/components/Experience";
import { HowIWork } from "@/components/HowIWork";
import { Tools } from "@/components/Tools";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CvRequestModal } from "@/components/CvRequest";
import { AdminPage } from "@/components/AdminPage";

function App() {
  const isAdminRoute = window.location.pathname.startsWith("/anfragen");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  if (isAdminRoute) {
    return (
      <div className="bg-paper text-ink font-sans min-h-screen" data-testid="admin-root">
        <Noise />
        <AdminPage />
      </div>
    );
  }

  return (
    <LanguageProvider>
      <div className="bg-paper text-ink font-sans min-h-screen" data-testid="app-root">
        <Noise />
        <Header />
        <main className="pt-16">
          <Hero />
          <Einsatz />
          <CaseStudies />
          <MoreProjects />
          <HowIWork />
          <Experience />
          <Tools />
          <Contact />
        </main>
        <Footer />
        <CvRequestModal />
        <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0, background: "#222220", color: "#F4F3ED", border: "1px solid rgba(244,243,237,0.2)", fontFamily: "IBM Plex Mono, monospace", fontSize: "12px" } }} />
      </div>
    </LanguageProvider>
  );
}

export default App;
